var _style, _path, _path2, _path3, _path4, _path5, _ellipse, _rect, _path6, _rect2, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _path7, _rect3, _rect4, _rect5, _g, _rect6, _rect7, _path8, _rect8, _rect9, _path9, _rect10, _path10, _path11, _path12, _path13, _path14, _rect11, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLukeHilt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 35 200",
    style: {
      enableBackground: "new 0 0 35 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0lsh{fill:#777777;}\r\n\t.st1lsh{fill:#42413F;}\r\n\t.st2lsh{fill:#9C7134;}\r\n\t.st3lsh{fill:#161616;}\r\n\t.st4lsh{fill:#888988;}\r\n\t.st5lsh{fill:#222323;}\r\n\t.st6lsh{fill:#68672A;}\r\n\t.st7lsh{fill:#7A7A7A;}\r\n\t.st8lsh{fill:#141414;}\r\n\t.st9lsh{fill:#694A2D;}\r\n\t.st10lsh{fill:#696969;}\r\n\t.st11lsh{fill:#888989;}\r\n\t.st12lsh{fill:#727272;}\r\n\t.st13lsh{fill:#818484;}\r\n\t.st14lsh{fill:#8D8D8E;}\r\n\t.st15lsh{fill:#ADADAD;}\r\n\t.st16lsh{fill:#999998;}\r\n\t.st17lsh{fill:#9E9E9B;}\r\n\t.st18lsh{fill:#9E9E9E;}\r\n\t.st19lsh{fill:#878787;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0lsh",
    d: "M31.8,8.9c-0.7-2.3-3.6-5-3.6-5c0,0-2-0.9-5.1-2.2c-0.4-0.5-0.9-0.9-1.3-1.4C21,0.2,20.1,0.1,19.3,0 c-0.9,0.1-1.7,0.2-2.6,0.3c-0.4,0.5-0.9,0.9-1.3,1.4c-3.1,1.4-5.1,2.2-5.1,2.2c0,0-2.9,2.7-3.6,5c-0.5,1.7-0.2,4.6,3.6,9.3 c0,2.2,0,4.5,0,6.7c3,1.6,6,3.2,9,4.9c3-1.6,6-3.2,9-4.9c0-2.2,0-4.5,0-6.7C32,13.5,32.3,10.6,31.8,8.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1lsh",
    d: "M10.3,18.3c2.6-0.4,5.7-0.7,9.1-0.7c3.3,0,6.3,0.3,8.9,0.7c0,0.1,0,0.2,0,0.3c-2.6-0.4-5.6-0.7-8.9-0.7 c-3.4,0-6.4,0.3-9.1,0.7C10.3,18.5,10.3,18.4,10.3,18.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1lsh",
    d: "M10.2,4c2.6-0.4,5.7-0.8,9.1-0.8c3.3,0,6.3,0.3,8.9,0.7c0.1,0.1,0.2,0.2,0.3,0.3c-2.7-0.4-5.8-0.6-9.2-0.6 c-3.4,0-6.6,0.2-9.4,0.6C10.1,4.1,10.2,4,10.2,4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2lsh",
    d: "M11,45c-0.1-2.5-0.1-5-0.2-7.5c1.3-0.8,2.6-1.6,3.9-2.4c3.1,0,6.2,0,9.3,0c1.4,1,2.9,2,4.3,2.9c0,2.5,0,5,0,7.5 C22.6,45.4,16.8,45.2,11,45z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2lsh",
    d: "M24.2,38.4h-9c0-3.6,0-7.2,0-10.8c0-0.2,0-0.5,0-0.7c3,0,6,0,9,0V38.4z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2lsh",
    cx: 19.7,
    cy: 26.8,
    rx: 4.5,
    ry: 2.7
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.6,
    y: 47.1,
    className: "st3lsh",
    width: 9.3,
    height: 12.4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3lsh",
    d: "M15.5,49.9C12,49.7,9.8,47.5,9.8,46c0.1-1.4,2.4-3.2,5.7-3.1c2.6,0,5.3-0.1,7.9-0.1c3.7,0.6,6.1,2.3,6.1,3.6 c-0.1,1.3-2.6,2.6-6.1,2.8C20.8,49.4,18.1,49.7,15.5,49.9z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.2,
    y: 54.9,
    className: "st3lsh",
    width: 13.4,
    height: 52.5
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st4lsh",
    cx: 19.9,
    cy: 58.1,
    rx: 9.3,
    ry: 2.6
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st3lsh",
    cx: 19.9,
    cy: 63.3,
    rx: 9.3,
    ry: 2.6
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st4lsh",
    cx: 19.8,
    cy: 68.5,
    rx: 9.3,
    ry: 2.6
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st4lsh",
    cx: 20,
    cy: 78.6,
    rx: 9.3,
    ry: 2.6
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st3lsh",
    cx: 20,
    cy: 73.4,
    rx: 9.3,
    ry: 2.6
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st4lsh",
    cx: 20,
    cy: 88.8,
    rx: 9.3,
    ry: 2.6
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st3lsh",
    cx: 19.8,
    cy: 83.8,
    rx: 9.3,
    ry: 2.6
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st4lsh",
    cx: 20,
    cy: 99,
    rx: 9.3,
    ry: 2.6
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st3lsh",
    cx: 19.8,
    cy: 94,
    rx: 9.3,
    ry: 2.6
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3lsh",
    d: "M10.3,111.4c0-2.1,0-3.5,0-3.5l0,0c0,0,1.3-0.7,3.3-1.7c4.2,0,8.4,0,12.6,0c1.4,0.9,2.8,1.8,4.2,2.6 c0,1.2,0,2.4,0,3.6C23.7,112,17,111.7,10.3,111.4z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3.2,
    y: 112,
    className: "st5lsh",
    width: 2.7,
    height: 35.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 5.9,
    y: 112.4,
    className: "st6lsh",
    width: 4,
    height: 35.1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 3.2,
    y: 112,
    className: "st7lsh",
    width: 6.7,
    height: 18
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st8lsh",
    points: "6.6,124.4 8.6,122.1 4.6,122.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8lsh",
    points: "4.6,119.2 8.6,119.2 6.6,116.9  "
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    y: 112,
    className: "st9lsh",
    width: 3.2,
    height: 35.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 10.9,
    y: 173.3,
    className: "st10lsh",
    width: 19.2,
    height: 9.9
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st10lsh",
    d: "M29.8,174.1H11.1c-0.9,0-1.5-0.7-1.5-1.5v-60.5c0-0.9,0.7-1.5,1.5-1.5h18.6c0.9,0,1.5,0.7,1.5,1.5v60.5 C31.3,173.4,30.6,174.1,29.8,174.1z"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 174.1,
    className: "st1lsh",
    width: 19.2,
    height: 0.3
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 9.6,
    y: 147.2,
    className: "st1lsh",
    width: 21.7,
    height: 0.3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st11lsh",
    d: "M10.7,196.7c1.3,1,4.7,3.3,9.5,3.3c4.6,0,7.9-2.3,9.2-3.3c0-2.1,0-4.1-0.1-6.2c-6.2,0-12.4,0-18.6,0.1 C10.7,192.7,10.7,194.7,10.7,196.7z"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 11.3,
    y: 186.4,
    className: "st12lsh",
    width: 17.6,
    height: 8.8
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st11lsh",
    d: "M8.9,185.3c-0.1-1.3-0.3-2.7-0.4-4c0.8-0.5,1.5-1.1,2.3-1.6c1.9,1.1,4.8,2.4,8.6,2.7c4.8,0.3,8.6-1.4,10.7-2.5 c1,1,2.1,2,3.1,2.9c-1,1.8-2.1,3.5-3.1,5.3c-3.8-0.2-7.8-0.2-11.9-0.1c-2.7,0.1-5.3,0.2-7.8,0.3C10,187.3,9.4,186.3,8.9,185.3z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st13lsh",
    d: "M34.7,185.7c0-1.1,0-2.3-0.1-3.4c-0.9,0-1.7,0.1-2.6,0.1c0,1-0.1,2-0.1,3C32.9,185.5,33.8,185.6,34.7,185.7z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st14lsh",
    d: "M31.3,180.9c0.6,0,1.1,0,1.7,0c0.6,0.5,1.1,1,1.7,1.4c-0.9,0-1.7,0.1-2.6,0.1 C31.8,181.9,31.6,181.4,31.3,180.9z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st13lsh",
    d: "M6.1,182.4c0,1.1,0.1,2.3,0.1,3.4c0.9-0.3,1.7-0.5,2.6-0.8c-0.1-1-0.1-1.9-0.2-2.9 C7.8,182.2,7,182.3,6.1,182.4z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st14lsh",
    d: "M8.2,180.8c-0.7,0.5-1.4,1.1-2.1,1.6c0.8,0,1.6,0,2.3,0c0.4-0.5,0.7-1,1.1-1.6C9.1,180.8,8.7,180.8,8.2,180.8z "
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 17.4,
    y: 188.9,
    className: "st15lsh",
    width: 6,
    height: 6.5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st16lsh",
    d: "M28.3,193c0-2.2-0.1-4.4-0.1-6.5c1.5,0.2,2.9,0.3,4.4,0.5c0,2.1,0,4.2,0.1,6.3C31.2,193.1,29.8,193.1,28.3,193 z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st17lsh",
    d: "M34.9,185.6c-0.8,0.5-1.5,1.1-2.3,1.6c0,2,0,4,0,5.9c0.8-0.6,1.6-1.1,2.3-1.7C35,189.6,34.9,187.6,34.9,185.6z "
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st15lsh",
    d: "M31.9,184.6c-1.2,0.6-2.4,1.2-3.6,1.9c1.5,0.3,3,0.6,4.4,0.9c0.7-0.6,1.5-1.1,2.2-1.7 C33.9,185.3,32.9,184.9,31.9,184.6z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st16lsh",
    d: "M12.5,186.6c0,2.1-0.1,4.2-0.1,6.3c-1.4,0-2.8,0-4.3,0c-0.1-2.1-0.1-4.1-0.2-6.2 C9.5,186.6,11,186.6,12.5,186.6z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st17lsh",
    d: "M5.7,191.5c0.8,0.4,1.7,0.9,2.5,1.3c0-1.9,0-3.9,0-5.8c-0.8-0.4-1.6-0.8-2.5-1.2 C5.7,187.7,5.7,189.6,5.7,191.5z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st15lsh",
    d: "M8.6,184.6c-1,0.4-1.9,0.8-2.9,1.2c0.8,0.4,1.6,0.8,2.5,1.2c1.5-0.1,2.9-0.3,4.4-0.4 C11.2,185.9,9.9,185.3,8.6,184.6z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st18lsh",
    d: "M24.1,189.3c-2.5,0-5,0-7.6,0c0-0.3,0-0.6,0-0.8c2.5,0,5,0,7.6,0C24.1,188.7,24.1,189,24.1,189.3z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st19lsh",
    d: "M24.2,194.5c-0.3,0.3-0.5,0.6-0.8,0.9c0-2,0-4.1,0-6.1c0.3-0.3,0.5-0.5,0.8-0.8 C24.2,190.4,24.2,192.5,24.2,194.5z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st19lsh",
    d: "M16.5,194.6c0.3,0.3,0.6,0.5,0.9,0.8c0-2,0-4.1,0-6.1c-0.3-0.3-0.6-0.6-0.8-0.9 C16.6,190.5,16.6,192.5,16.5,194.6z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLukeHilt);
export default __webpack_public_path__ + "static/media/luke-hilt.c40471a5.svg";
export { ForwardRef as ReactComponent };